// FILE: src/firebase.js
import { initializeApp, getApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCghVh6LUQHSpaBNKNhHQq3Jmu8yo3kjxo',
  authDomain: 'lifelink-ai-3c03b.firebaseapp.com',
  projectId: 'lifelink-ai-3c03b',
  storageBucket: 'lifelink-ai-3c03b.appspot.com',
  messagingSenderId: '619935880971',
  appId: '1:619935880971:web:2a7e8fad98c0bd6870340e'
};

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const db = getFirestore(app);
